import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { serviceReducer, teacherReducer } from './reducers';
import filtersReducer from "./filtersSlice";
import authReducer from './authSlice';
import settingsReducer from './settingsSlice';

const store = configureStore({
  reducer: combineReducers({
    services: serviceReducer,
    teachers: teacherReducer,
    auth: authReducer,
    filters: filtersReducer,
    settings: settingsReducer,
  })
});
  
export default store;